import { Capacitor } from '@capacitor/core';

/** One-time Capacitor setup: edge-to-edge shell, no document scroll, keyboard resize off. */
export function initNativeApp() {
  if (!Capacitor.isNativePlatform()) return;

  document.documentElement.classList.add('native-app');

  void (async () => {
    try {
      const { StatusBar, Style } = await import('@capacitor/status-bar');
      await StatusBar.setOverlaysWebView({ overlay: true });
      await StatusBar.setStyle({ style: Style.Light });
    } catch {
      /* status bar plugin unavailable */
    }

    try {
      const { Keyboard, KeyboardResize } = await import('@capacitor/keyboard');
      await Keyboard.setResizeMode({ mode: KeyboardResize.None });
      await Keyboard.setScroll({ isDisabled: true });
    } catch {
      /* keyboard plugin unavailable */
    }
  })();

  const viewport = window.visualViewport;
  const preventViewportScroll = () => {
    if (viewport?.offsetTop) window.scrollTo(0, 0);
  };
  viewport?.addEventListener('scroll', preventViewportScroll);
  viewport?.addEventListener('resize', preventViewportScroll);
}

export function isNativeApp() {
  return Capacitor.isNativePlatform();
}
